export default "__VITE_ASSET__c6bc04c7__"